/**
 * Yumuşak düzenin ortak sınıfları (mobildeki grup sekmeleriyle aynı dil):
 * açık zeminli sabit özet şeridi, tam genişlik çizgili satırlar, hafif yazılar.
 * Koyu tema <html class="dark"> ile gelir (ThemeModeContext).
 */
export const soft = {
  // Üstte sabit özet şeridi.
  summary:
    "shrink-0 px-5 py-4 bg-terakkiBrandCloud border-b border-terakkiBorder dark:bg-white/5 dark:border-white/15",
  // Tam genişlik satır.
  row: "flex items-center gap-3.5 px-5 py-3.5 border-b border-terakkiBorder dark:border-white/15",
  rowButton:
    "w-full text-left flex items-center gap-3.5 px-5 py-3.5 border-b border-terakkiBorder dark:border-white/15 hover:bg-terakkiBrandCloud dark:hover:bg-white/5 transition-colors",
  ink: "text-terakkiInk dark:text-white",
  muted: "text-terakkiNeutral dark:text-white/70",
  faint: "text-terakkiNeutral/80 dark:text-white/45",
  accent: "text-terakkiPrimaryDark dark:text-terakkiBrandSoft",
  track: "h-1 rounded-full bg-terakkiBrandMist dark:bg-white/10 overflow-hidden",
  fill: "h-full rounded-full bg-terakkiBrand dark:bg-terakkiBrandSoft",
  chip: "bg-terakkiBrandCloud dark:bg-white/10",
  sectionTitle:
    "px-5 pt-5 pb-1.5 text-xs font-medium tracking-wide text-terakkiNeutral dark:text-white/70",
  empty: "flex flex-col items-center gap-2 py-10 text-sm text-terakkiNeutral dark:text-white/70",
};

/** Kıyas farkının rengi: artış yeşil, düşüş kırmızı, eşit soluk. */
export function deltaClass(delta) {
  if (delta === null || delta === undefined) return "";
  if (delta > 0) return "text-[#2E9E6A] dark:text-[#7BE3A8]";
  if (delta < 0) return "text-terakkiError dark:text-[#F2A59C]";
  return "text-terakkiNeutral dark:text-white/45";
}
